/* eslint-disable array-callback-return */
import React from 'react';
import PlayerCard from './PlayerCard';

const MyTeam = (props) => {
  ///check cookie for user name / email
  // match against the db.users to find the user id for the room
  // db.players where their team equals users team id
    const myTeam = Number(props.myTeam);
    const currentPick = props.currentPick;
    const players = props.players;
    const isAdmin = props.isAdmin;
    const isMyTurn = props.isMyTurn;
    const myName = props.me;
    const myPlayers = players.filter(x => x.team === myTeam);
    const myPlayerList = myPlayers.map((player)=>{
        return  (
            <PlayerCard key={player.pid + '_myTeam'} player={player} currentPick={currentPick} isAdmin={isAdmin} isMyTurn={isMyTurn} myTeam={myTeam} />
        )
    })
    
    return  (
      <div id="my-team">
        <div className="team-box" data-teambox={myName}>
          <div className="team-interior">
            <h3 className="team-header">{myName}</h3>
            <ol id={'team'+myTeam} data-team={myTeam} className={'team-list team' + myTeam}>
                {myPlayerList}
            </ol>
          </div>
        </div>
      </div>
    )
};

export default MyTeam;